import { computed, debug, NetbankingAPI, observable } from "aaa";
import { action } from "mobx";
import { NetbankingAPIClient } from "network/APIClient";
import { OffersStore } from "stores/OffersStore";
import profileStore from "stores/ProfileStore";
import { IAmount } from "types/amount";
import { ContactsStore } from "../../stores/ContactsStore";

export class HouseholdInsuranceStore {
    @observable contactsStore: ContactsStore;
    @observable offersStore: OffersStore;
    @observable _isLoading = true;
    @observable calculationFee?: IAmount;
    @observable isError = false;
    @observable isCalculating = false;
    @observable handoverUrl: string = "";

    constructor() {
        this.contactsStore = new ContactsStore(false, true);
        this.offersStore = new OffersStore(
            ["HOUSEHOLD_INSURANCE"]
        );
    }

    @computed get isLoading() {
        return this._isLoading
            || profileStore.isLoading
            || this.contactsStore.isLoading
            || this.offersStore.isLoading;
    }

    @action async loadData() {
        try {
            this._isLoading = true;

            await Promise.all([
                this.contactsStore.load(),
                this.offersStore.load()
            ]);

            this._isLoading = false;
        } catch (error) {
            debug.log("[HouseholdInsuranceStore] loadData error:", error);

            throw error;
        }
    }

    @action async calculateHouseholdInsuranceFee(region: number, livingSpace: number) {
        try {
            this.isCalculating = true;
            this.isError = false;
            const target = NetbankingAPI.postHouseholdInsuranceCalculationData({ region, livingSpace });
            const response = await NetbankingAPIClient.requestType(target);
            this.calculationFee = response.monthlyFeeAmount;
        } catch {
            this.isError = true;
            this.calculationFee = undefined;
        } finally {
            this.isCalculating = false;
        }
    }

    @action async sendHouseholdInsuranceInterest() {
        if (
            this.contactsStore.selectedAddressId === undefined ||
            this.contactsStore.selectedEmailAddressId === undefined ||
            this.contactsStore.selectedPhoneId === undefined
        ) {
            return null;
        }


        const target = NetbankingAPI.createHouseholdInsurance({
            addressContactId: this.contactsStore.selectedAddressId,
            emailContactId: this.contactsStore.selectedEmailAddressId,
            mobilePhoneContactId: this.contactsStore.selectedPhoneId
        });
        const response = await NetbankingAPIClient.requestType(target);

        this.handoverUrl = response.url;
        return response.url;
    }
}



// WEBPACK FOOTER //
// ./src/components/householdInsurance/HouseholdInsuranceStore.ts